<div class="mat-elevation-z5">
    <mat-toolbar color="primary">
      <mat-icon svgIcon="{{data.icon}}"></mat-icon>
      <h1 class="mat-title">{{data.title}}</h1>
    </mat-toolbar>
  <div class="mat-body" [innerHTML]="data.message"></div>
  <div class="uf-action-row">
    <button mat-button mat-raised-button (click)="onNo()">Nee</button>
    <button mat-button mat-raised-button class="mat-primary" (click)="onYes()">Ja</button>
  </div>
</div>
